import React from 'react';
import { useAuth } from '../../context/AuthContext';

const AccountTab = ({ user }) => {
  const profile = user?.user_metadata || {};

  return (
    <div className="settings-section">
      <h2>Account Settings</h2>
      <p className="description">View your account information</p>

      <div className="settings-section">
        <h3>Profile Information</h3>
        <div className="form-group">
          <label>Username</label>
          <input
            type="text"
            className="form-input"
            value={profile.username || 'Not set'}
            disabled
          />
        </div>
        <div className="form-group">
          <label>Email Address</label>
          <input
            type="email"
            className="form-input"
            value={user?.email || ''}
            disabled
          />
        </div>
        <p style={{ fontSize: '0.8125rem', color: '#6b7280', marginTop: '8px' }}>
          To update your account information, please contact support.
        </p>
      </div>
    </div>
  );
};

export default AccountTab;
